import { SpinnerGap } from '@phosphor-icons/react';
import { Tag } from '@vake/ui-kit';
import styled from 'styled-components';
import { elevatedTags } from '../../../shared/constants';

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
const MicroText = styled.div`
    font-family: Detail D1, sans-serif;
    font-size: 12px;
    line-height: 16px;
    tracking: 0px;
    color: #8e8e93;
`;

export const TagView = ({ tags }: { tags: string[] | null }) => {
    if (!tags) {
        // The tagging model is not ran
        return (
            <Row>
                <SpinnerGap size={10} color={'#8E8E93'} />
                <MicroText>{'tags awaiting'}</MicroText>
            </Row>
        );
    }
    return tags.map((tag: string, i: number) => (
        <Tag key={i} variant={elevatedTags.includes(tag) ? 'warning' : 'neutral'} size="small" subtle={false}>
            {tag}
        </Tag>
    ));
};
